// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BJ8z8","input":"styles_input__LDSKl"};